module.exports = __webpack_public_path__ + "static/media/milk-grass-footer.fd7f1791.png";